import { Component, inject } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { LicenseDetailsComponent } from './details/license-details.component';
import * as licenses from 'build/licenses/npm-licenses.json';
import * as cocoapodsLicenses from 'build/licenses/cocoapods-licenses.json';
import * as gradleLicenses from 'build/licenses/gradle-licenses.json';
import { LicenseMetadata, License } from '../../licenses.model';

@Component({
    selector: 'app-licenses',
    templateUrl: './licenses.component.html',
    styleUrls: ['./licenses.component.scss'],
    imports: [IonicModule, TranslatePipe]
})
export class LicensesComponent {
  translate = inject(TranslateService);
  modalController = inject(ModalController);


  public LICENSES = (licenses as any).default as LicenseMetadata[];
  public COCOAPODS_LICENSES = (cocoapodsLicenses as any).default as LicenseMetadata[];
  public GRADLE_LICENSES = (gradleLicenses as any).default as LicenseMetadata[];

  public openLicense(license: LicenseMetadata) {
    this.modalController
    .create({
      component: LicenseDetailsComponent,
      componentProps: { license },
      presentingElement: document.querySelector('ion-modal')

    })
    .then((modal: HTMLIonModalElement) => modal.present());
  }

  licenseList(licensesList: License[]): string {
      let result = '';
      if (licensesList != null) {
          for (const l of licensesList) {
              if (result.length > 0) {
                  result += ', ';
              }
              result += l.name;
          }
      }
      return result;
  }
}
